module.exports = __webpack_public_path__ + "img/scan qr code_2048910.ddaad8e2.png";